import { render, staticRenderFns } from "./AnnotationPreview.vue?vue&type=template&id=af6d067e&scoped=true"
import script from "./AnnotationPreview.vue?vue&type=script&lang=js"
export * from "./AnnotationPreview.vue?vue&type=script&lang=js"
import style0 from "./AnnotationPreview.vue?vue&type=style&index=0&id=af6d067e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6d067e",
  null
  
)

export default component.exports